import { HTMLAttributes, useEffect } from 'react';
import PolicyModel from '@/dashboard/models/policys/PolicyModel';
import { useCancelPolicyRelatedInfo } from '@jove-frontend/uikit';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

type PolicyRefundInformationViewProps = HTMLAttributes<HTMLDivElement> & {
  policy: PolicyModel;
};

const PolicyRefundInformationView = (props: PolicyRefundInformationViewProps) => {
  const { policy, className } = props;
  const { refundPriceInfoList, evaluateCancelRefundPriceInfoList } = useCancelPolicyRelatedInfo();

  /**
   * effects
   */
  useEffect(() => {
    evaluateCancelRefundPriceInfoList(policy?.payload?.pre_cancel_info, { useOriginalPriceData: true });
  }, [policy]);

  return !!policy?.payload?.pre_cancel_info ? (
    <Box className={clsx('relative flex flex-col rounded-lg border border-[#D1D5DB] bg-[#F8FAFC] p-4 shadow-sm', className)}>
      <Box className="mb-3 border-b border-[#E5E7EB] pb-2">
        <Typography variant="subtitle1" className="font-black text-[#111827]">
          Refund Information
        </Typography>
      </Box>
      <Box className="flex flex-col space-y-2">
        {refundPriceInfoList.map((item, index) => {
          const isHighlight = !!item.bolder;

          return (
            <Box
              key={index}
              className={clsx(
                'flex items-start justify-between rounded-md px-3 py-2',
                isHighlight ? 'border border-[#FCA5A5] bg-[#FEE2E2]' : 'border border-[#E5E7EB] bg-white'
              )}
            >
              <Typography variant="subtitle1" className={clsx('pr-4', isHighlight ? 'font-black text-[#991B1B]' : 'font-semibold text-[#374151]')}>
                {item.title}
              </Typography>
              <Typography variant="subtitle1" className={clsx('text-right', isHighlight ? 'font-black text-[#B91C1C]' : 'font-bold text-[#111827]')}>
                {item.content}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  ) : null;
};

export default PolicyRefundInformationView;
